<template>
    <div>
        <div class="loading-full-page" v-if="isLoadingPagePayment">
            <b-card>
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card>
        </div>
        <div class="loading-full-page" v-else-if="isLoadingPage">
            <b-card>
                <b-skeleton animation="wave" width="85%"></b-skeleton>
                <b-skeleton animation="wave" width="55%"></b-skeleton>
                <b-skeleton animation="wave" width="70%"></b-skeleton>
            </b-card>
        </div>
        <div
            v-else
            class="section-checkout"
            :class="{
                'bgr-white': step === 2,
                'no-padding': listCheckouts.length === 0,
                'padding-bottom': isScroll,
            }"
        >
            <div class="section-checkout__background"></div>

            <NoEmpty
                v-if="listCheckouts.length === 0"
                :description="`${getTranslatedText(
                    'There are no entries in your cart. Click on start to purchase your Green Certificate.'
                )}`"
                :isShowEmptyCart="true"
            />

            <template v-else>
                <template v-if="step === 1">
                    <div class="section-checkout__head">
                        <h1 class="section-checkout__head__title" v-html="getTranslatedText('this week’s grand prize is')"></h1>
                        <span class="section-checkout__head__price">
                            <b>{{ getTranslatedText(currencyCode) }}</b>
                            {{ formatNumberWinners(1) }}
                        </span>
                        <span class="section-checkout__head__description">
                            {{
                                getTranslatedText(
                                    "each green certificate is valid for one entry."
                                )
                            }}
                        </span>
                    </div>
                    <div class="section-checkout__breadcrumbs">
                        <ButtonCustom
                            classBtn="section-checkout__breadcrumbs-btn"
                            classOption="btn-radius"
                            typeBtn="primary"
                            type="primary"
                            text="shopping cart"
                        />
                        <p class="section-checkout__breadcrumbs__description">
                            {{
                                getTranslatedText(
                                    "You're one step away from participating on the Greenest Draw on Earth."
                                )
                            }}
                        </p>
                    </div>

                    <div class="section-checkout__items">
                        <div
                            v-for="(item, index) in listCheckouts"
                            :key="index"
                            class="section-checkout__item"
                        >
                            <div class="section-checkout__item__top">
                                <div class="section-checkout__item__left">
                                    <div class="section-checkout__item__left__box-content">
                                        <div class="section-checkout__item__left__image">
                                            <img class="show-desktop" src="@/assets/images/tickets/mobile-screen.png" />
                                            <img class="show-mobile" src="@/assets/images/tickets/phone-mb.png" />
                                        </div>
                                        <div class="section-checkout__item__left__content">
                                            <div class="section-checkout__item__left__content-header">
                                                <div class="section-checkout__item__left__content-header__name">
                                                    {{ renderTitleTicket(item.name) }}
                                                </div>
                                                <div class="section-checkout__item__numbers">
                                                    <div v-for="(number, index) in item.bets" :key="index" :class="`section-checkout__item__number ${renderClass( number)}`">
                                                        <div class="box-number">
                                                            <a> {{ renderNumberLocale(number) }} </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="section-checkout__item__left__content-drawdate">
                                                <label>{{  getTranslatedText("draw date")}}:</label>
                                                {{ item.draw_date }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="section-checkout__item__buttons">
                                        <div
                                            @click="handleEditInfoItem(item.idBlock)"
                                            class="section-checkout__item__btn__edit t-transform-cap"
                                        >
                                            <img
                                                src="@/assets/images/common/edit.png"
                                            />
                                            {{ getTranslatedText("edit") }}
                                        </div>
                                        <div
                                            @click="onClickConfirmModal(item.id)"
                                            class="section-checkout__item__btn__delete t-transform-cap"
                                        >
                                            <img
                                                src="@/assets/images/common/trash.png"
                                            />
                                            {{ getTranslatedText("delete") }}
                                        </div>
                                    </div>
                                </div>
                                <img class="section-checkout__line show-mobile" src="@/assets/images/tickets/line.png" />
                                <div class="section-checkout__item__right">
                                    <div class="section-checkout__item__right__header">
                                        <div v-if="item.doubles && item.doubles[0]?.isCheck" class="section-checkout__item__right__header-double">
                                            {{ getTranslatedText("OMR") }}
                                            {{ formatNumberWinners(2) }}
                                        </div>
                                        <div class="section-checkout__item__right__header-value">
                                            {{ getTranslatedText("OMR") }}
                                            <span class="section-checkout__price">{{ formatLocalePrice(item.amount) }}</span>
                                        </div>
                                    </div>
                                    <div class="section-checkout__item__check">
                                        <div v-for="(check, key) in item.doubles" :key="key" class="section-checkout__item__check-items">
                                            <div class="section-checkout__item__check__left">
                                                <div class="section-checkout__item__check__input">
                                                    <input type="checkbox" :checked="check.isCheck" @click="onChangeDouble(index,key)" />
                                                </div>
                                                <div class="section-checkout__item__check__text" >
                                                    {{ check.title }}
                                                    <img
                                                        style="cursor: pointer"
                                                        src="@/assets/images/checkout/info-green.png"
                                                        v-b-tooltip.hover
                                                        :title="
                                                            check.id === 2
                                                                ? getTranslatedText(
                                                                      'Selecting ‘secure the grand prize’ will allow you to secure your total winnings without splitting your winnings with other winners of the grand prize.'
                                                                  )
                                                                : getTranslatedText(
                                                                      'Selecting ‘double the grand prize’ will allow you to double your total winning prize.'
                                                                  )
                                                        "
                                                    />
                                                </div>
                                            </div>
                                            <div class="section-checkout__item__check__value">
                                                {{ getTranslatedText("OMR") }}
                                                <span class="section-checkout__price">{{ formatLocalePrice(check.value) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="section-checkout__item__right__description"
                                        v-html="getTranslatedText('win your best life and select both option double and secure the grand prize')">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="section-checkout__footer">
                        <p class="section-checkout__footer-description">
                            {{ getTranslatedText("by clicking on the “checkout” button, you agree to our terms and conditions. all transactions are charged in omr and are inclusive of vat. prices displayed in other currencies are for informative purposes only and are converted according to actual exchange rates.") }}
                        </p>
                        <div class="section-checkout__footer-action is-scroll">
                            <div class="section-checkout__footer-action-button">
                                <ButtonCustom
                                    classOption="btn-radius color-red"
                                    classBtn="section-checkout__button-red"
                                    typeBtn="primary"
                                    type="primary"
                                    text="back"
                                    iconLeft="arrow-left-white.png"
                                    :isDisabled="isLoadingBtn || isLoadingPayment || isLoadingBtnClear"
                                    @onClickButton="onGoBackPage"
                                />

                                <ButtonCustom
                                    classOption="btn-radius color-red"
                                    classBtn="section-checkout__button-red btn-clear-all"
                                    typeBtn="primary"
                                    type="primary"
                                    text="clear all"
                                    :isDisabled="isLoadingBtn || isLoadingPayment"
                                    :isLoading="isLoadingBtnClear"
                                    @onClickButton="onClickConfirmModal(-1)"
                                />
                            </div>
                            <div class="section-checkout__footer-action-info">
                                <div class="section-checkout__footer-action-price">
                                    {{ getTranslatedText("total amount") }}:
                                    <div class="section-checkout__footer-action-price__value">
                                        {{ getTranslatedText(currencyCode) }}
                                        <span>{{ formatLocalePrice(totalAmount) }}</span>
                                    </div>
                                </div>
                                <ButtonCustom
                                    :isDisabled="isLoadingBtnClear"
                                    :isHiddenValue="isLoadingBtn || isLoadingPayment "
                                    :isLoading="isLoadingBtn || isLoadingPayment"
                                    classBtn="section-checkout__button-checkout"
                                    classOption="btn-radius"
                                    typeBtn="primary"
                                    type="primary"
                                    text="checkout"
                                    @onClickButton="handlePay"
                                />
                            </div>
                        </div>
                    </div>
                </template>
                <ConfirmModal
                    id="modal-confirm-remove-block"
                    :title="
                        getTranslatedText('are you sure you want to delete?')
                    "
                    :description="
                        getTranslatedText(
                            'once the number is deleted cannot be recovered. Do you want to delete it?'
                        )
                    "
                    textBtnCancel="Cancel"
                    textBtnDelete="Delete"
                    :isLoadingButton="isLoadingButtonConfirm"
                    :showBtnCancel="true"
                    @onCancelModal="onCancelRemove"
                    @onDelete="
                        idIndex !== -1
                            ? handleDeleteInfoItem(idIndex)
                            : onClearCart()
                    "
                />
            </template>
            <template v-if="step === 2">
                <CardDetail
                    :totalAmount="totalAmountPayment"
                    :paramCheckout="paramCheckout"
                    :isRecurring="isRecurring"
                    @onClickGoBack="onClickGoBack"
                    @showToast="showToast"
                />
            </template>
            <div v-if="this.listCards.length > 0">
                <vue-bottom-sheet max-height="90%" ref="bottomChangeCard">
                    <BottomSheet :isHiddenBtn="true">
                        <template slot="body-sheet">
                            <div class="section-add-credit__bottom-change-card">
                                <h1
                                    class="section-add-credit__bottom-change-card-title t-transform-cap"
                                >
                                    {{
                                        getTranslatedText("select credit card")
                                    }}
                                </h1>
                                <FormCommon
                                    :formItem="formItem"
                                    @onSubmitForm="onSubmitChangeCard"
                                >
                                    <template slot="radioButtonCard">
                                        <b-form-group>
                                            <b-form-radio
                                                v-model="cardId"
                                                class="section-add-credit__item-card"
                                                v-for="(
                                                    item, index
                                                ) in listCards"
                                                :value="item.id"
                                                :key="index"
                                                ><div
                                                    class="section-add-credit__change-card"
                                                >
                                                    <div
                                                        class="section-add-credit__change-card-info"
                                                    >
                                                        <h4
                                                            class="section-add-credit__change-card-info-number"
                                                        >
                                                            {{
                                                                item.card_number
                                                            }}
                                                        </h4>
                                                        <p
                                                            class="section-add-credit__change-card-info-description t-fir-transform-cap"
                                                        >
                                                            {{
                                                                getTranslatedText(
                                                                    "valid thru 24/28"
                                                                )
                                                            }}
                                                        </p>
                                                        <p
                                                            class="section-add-credit__change-card-info-name"
                                                        >
                                                            {{
                                                                item.card_holder_name
                                                            }}
                                                        </p>
                                                        <div
                                                            v-if="
                                                                item.is_default
                                                            "
                                                            class="section-add-credit__change-card-info-default t-transform-cap"
                                                        >
                                                            {{
                                                                getTranslatedText(
                                                                    "marked as default"
                                                                )
                                                            }}
                                                        </div>
                                                    </div>
                                                    <img
                                                        class="section-add-credit__card-type"
                                                        :src="
                                                            require(`@/assets/images/common/${renderTypeCard(
                                                                item.card_type_name
                                                            )}`)
                                                        "
                                                        alt="card"
                                                    />
                                                </div>
                                            </b-form-radio>
                                        </b-form-group>
                                        <div class="bottom-change-card">
                                            <ButtonCustom
                                                typeBtn="button"
                                                type="default"
                                                classBtn="button-change-card"
                                                text="add new card"
                                                @onClickButton="
                                                    $router.push(
                                                        '/manage-cards'
                                                    )
                                                "
                                            />
                                            <ButtonCustom
                                                typeBtn="submit"
                                                type="primary"
                                                classBtn="button-change-card"
                                                text="select"
                                                :isLoading="isLoadingChangeCard"
                                            />
                                        </div>
                                    </template>
                                </FormCommon>
                            </div>
                        </template>
                    </BottomSheet>
                </vue-bottom-sheet>
            </div>

            <MethodPayment
                id="modalMethodPayment"
                :totalAmountPayment="totalAmountPayment"
                @showToast="showToast"
                methodPayment="2"
            />
            <b-modal
                id="input-ccv"
                centered
                v-model="modalShowCvv"
                :title="getTranslatedText('CVV')"
                :hide-footer="true"
            >
                <div class="input-ccv">
                    <b-form-input
                        :state="stateCvv"
                        id="input-live"
                        v-model="card_security_code"
                        type="password"
                        aria-describedby="input-live-cvv"
                        :placeholder="getTranslatedText('Enter cvv')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-live-cvv">
                        {{ getTranslatedText("enter 3 numbers") }}
                    </b-form-invalid-feedback>
                    <ButtonCustom
                        typeBtn="button"
                        type="primary"
                        text="Done"
                        @onClickButton="onAddSvv"
                    />
                </div>
            </b-modal>
            <Toast :title="toastData.message" :type="toastData.type" />
        </div>
    </div>
</template>
<script>
import "@/assets/scss/mobile/wallet/_wallet.scss";
import {
    creditCardMask,
    formatNumberMoney,
    idRandom,
    isArrayEmpty,
    isStrEmpty,
    removeDouble,
    renderLocaleNumber,
    renderLocalePrice,
} from "@/components/common/utils";
import { getUserInfo } from "@/services/axios";

import gameService from "@/services/game.service";
import toolService from "@/services/tool.service";
import authService from "@/services/auth.service";
import PaymentService from "@/services/payment.servive";

import ConfirmModal from "@/components/common/confirm";
import NoEmpty from "@/components/common/no-empty";
import ButtonCustom from "@/components/common/button";
import FormCommon from "@/components/common/form";
import BottomSheet from "@/components/common/bottom-sheet";
import MethodPayment from "@/components/common/methodPayment";

import CardDetail from "@/views/mobile/card/index.vue";
import cardService from "@/services/card.service";

import languageMixin from "@/mixins/language/language-mixin";
import paymentMixin from "@/mixins/payment/payment-mixin";

import Toast from "@/components/common/toast/Toast.vue";
import moment from "moment";

const ENABLE_MANAGE_CREDIT_CARDS =
    process.env.VUE_APP_ENABLE_MANAGE_CREDIT_CARDS;
const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

export default {
    mixins: [languageMixin, paymentMixin],
    components: {
        ConfirmModal,
        NoEmpty,
        CardDetail,
        ButtonCustom,
        FormCommon,
        BottomSheet,
        Toast,
        MethodPayment,
    },
    data() {
        return {
            toastData: {
                message: "",
                type: "",
            },
            cssProps: {
                backgroundImage: `url(${require("@/assets/images/checkout/background-ball.png")})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            },
            selectedPayment: "",
            cardId: -1,
            cardSelect: {
                id: -1,
            },
            listCheckouts: [],
            isScroll: false,
            listCards: [],
            isLoadingChangeCard: false,
            isLoadingButtonConfirm: false,
            isLoadingBtn: false,
            isLoadingBtnClear: false,
            isShowListCard: false,
            step: 1,
            minimumBall: -1,
            maxiumBlue: -1,
            maxiumGreen: -1,
            totalAmount: 0,
            idIndex: "",
            card_security_code: "",
            modalShowCvv: false,
            totalAmountPayment: 0,
            paramCheckout: [],
            stateCvv: null,
            isRecurring: false,
            timer: null,
            isLoadingPage: false,
            currencyCode: CURRENCY_CODE,
            formItem: [
                {
                    type: "slot",
                    nameSlot: "radioButtonCard",
                },
            ],
        };
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.onScroll);
    },
    created() {
        this.fetchDataListCart();
        this.fetchDataTool();
        if (ENABLE_MANAGE_CREDIT_CARDS !== "no") {
            this.getListCards();
        }
    },
    methods: {
        showToast(message, type) {
            this.toastData.message = message;
            this.toastData.type = type;
            this.$bvToast.show("my-toast");
        },

        getListCards() {
            cardService.listCards().then((res) => {
                if (res.status === 200 && !isArrayEmpty(res.data)) {
                    let index = res.data.findIndex((x) => x.is_default);
                    index = index !== -1 ? index : 0;
                    this.cardSelect = res.data[index];
                    this.cardId = res.data[index].id;
                    this.listCards = res.data;
                }
            });
        },

        async fetchDataTool() {
            try {
                const respTool = await toolService.getValidateTicket();

                this.minimumBall = respTool.minMaxTickets[0];
                this.maxiumBlue = respTool.maxiumBlue;
                this.maxiumGreen = respTool.maxiumGreen;
            } catch (error) {
                console.log(error);
            }
        },

        async callApiListCart() {
            let totalCart = !isStrEmpty(localStorage.getItem("total_items"))
                ? parseInt(localStorage.getItem("total_items"))
                : 0;
            try {
                const resp = await authService.getListCart();
                if (resp.status === 200) {
                    let list_block_tmp =
                        totalCart > 0
                            ? JSON.parse(localStorage.getItem("list_block_tmp"))
                            : [];
                    let list_block_api =
                        parseInt(resp.data?.amount) > 0
                            ? JSON.parse(resp.data.cart_data)
                            : [];

                    if (!isArrayEmpty(list_block_tmp)) {
                        list_block_tmp = list_block_api.concat(list_block_tmp);
                        list_block_tmp = [...new Set(list_block_tmp)];

                        let amount = 0;

                        list_block_tmp = list_block_tmp.filter(
                            (v, i, a) =>
                                a.findIndex((v2) => v2.id === v.id) === i
                        );

                        list_block_tmp.map((x) => {
                            amount += x.date.length;
                        });

                        let param = {
                            cart_data: list_block_tmp,
                            items: list_block_tmp.length,
                            amount,
                        };

                        this.$store.dispatch(
                            "onChangeAnountCart",
                            parseInt(param.amount)
                        );
                        localStorage.setItem(
                            "list_block_tmp",
                            JSON.stringify(list_block_tmp)
                        );
                        localStorage.setItem(
                            "list_block",
                            JSON.stringify(list_block_tmp)
                        );
                        localStorage.setItem("total_items", param.amount);
                        this.fetchDataListCart();
                    } else {
                        let amount = resp?.data?.amount
                            ? parseInt(resp.data.amount)
                            : 0;

                        localStorage.setItem(
                            "list_block_tmp",
                            JSON.stringify(list_block_api)
                        );
                        localStorage.setItem(
                            "list_block",
                            JSON.stringify(list_block_api)
                        );
                        localStorage.setItem("total_items", amount);
                        this.fetchDataListCart();
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },

        async fetchDataListCart() {
            this.isLoadingPage = true;
            let listBlockTickets = localStorage.getItem("list_block_tmp");
            let listGames = localStorage.getItem("list_games");

            if (isStrEmpty(listBlockTickets) && this.$store.state.isLoggedIn) {
                this.callApiListCart();
                return false;
            }

            listGames = !isStrEmpty(listGames)
                ? [...JSON.parse(listGames)]
                : [];
            listBlockTickets = !isStrEmpty(listBlockTickets)
                ? [...JSON.parse(listBlockTickets)]
                : [];

            let paramAddToCard = [];

            listBlockTickets = listBlockTickets.filter(
                (x) =>
                    !isArrayEmpty(x.date) ||
                    x.automatically ||
                    x.numbersChecked.length >= this.minimumBall
            );

            listBlockTickets.map((value) => {
                if (value.automatically) {
                    let index = !isArrayEmpty(value.doubles)
                        ? value.doubles.findIndex(
                              (x) => x.id === listGames[0].event_id
                          )
                        : -1;
                    let itemListCart = {
                        id: idRandom(),
                        idBlock: value.id,
                        gameId: listGames[0].game_id,
                        name: `Entry ${paramAddToCard.length + 1}`,
                        game_slug: listGames[0].game_slug,
                        event_id: listGames[0].event_id,
                        amount: listGames[0].price,
                        date: listGames[0].draw_date,
                        draws: "1",
                        double_jackpot_price: parseFloat(
                            listGames[0].double_jackpot_price
                        ),
                        secure_jackpot_price: parseFloat(
                            listGames[0].secure_jackpot_price
                        ),
                        is_recurring: 1,
                        valueDoub: [],
                        amountDeducted: parseFloat(listGames[0].price),
                    };

                    if (index !== -1) {
                        itemListCart.valueDoub = value.doubles[index].value;
                    }
                    itemListCart["bets"] = value.numbersChecked;
                    paramAddToCard.push(itemListCart);
                } else {
                    value.date.map((v) => {
                        let indexGame = listGames.findIndex(
                            (x) => x.event_id.toString() === v
                        );
                        if (indexGame !== -1) {
                            let index = !isArrayEmpty(value.doubles)
                                ? value.doubles?.findIndex(
                                      (x) =>
                                          x.id === listGames[indexGame].event_id
                                  )
                                : -1;

                            let itemListCart = {
                                id: idRandom(),
                                idBlock: value.id,
                                gameId: listGames[indexGame].game_id,
                                name: `Entry ${paramAddToCard.length + 1}`,
                                game_slug: listGames[indexGame].game_slug,
                                event_id: listGames[indexGame].event_id,
                                amount: listGames[indexGame].price,
                                date: listGames[indexGame].draw_date,
                                draws: "1",
                                double_jackpot_price: parseFloat(
                                    listGames[indexGame].double_jackpot_price
                                ),
                                secure_jackpot_price: parseFloat(
                                    listGames[indexGame].secure_jackpot_price
                                ),
                                valueDoub: [],
                                amountDeducted: -1,
                            };

                            if (index !== -1) {
                                itemListCart.valueDoub =
                                    value.doubles[index].value;
                            }
                            itemListCart["bets"] = value.numbersChecked;
                            paramAddToCard.push(itemListCart);
                        }
                    });
                }
            });

            if (!isArrayEmpty(paramAddToCard)) {
                paramAddToCard.map((v) => {
                    this.totalAmount += parseFloat(v.amount);
                    v["draw_date"] = moment(v.date).format("DD/MM/YYYY");

                    if (v.valueDoub.includes(1)) {
                        this.totalAmount += parseFloat(v.double_jackpot_price);
                        if (v.amountDeducted !== -1) {
                            v.amountDeducted += parseFloat(
                                v.double_jackpot_price
                            );
                        }
                    }

                    if (v.valueDoub.includes(2)) {
                        this.totalAmount += parseFloat(v.secure_jackpot_price);
                        if (v.amountDeducted !== -1) {
                            v.amountDeducted += parseFloat(
                                v.secure_jackpot_price
                            );
                        }
                    }

                    v["doubles"] = [
                        {
                            id: 1,
                            isCheck: v.valueDoub.includes(1),
                            title: this.getTranslatedText(
                                "double your grand prize"
                            ),
                            value: v.double_jackpot_price,
                        },
                        {
                            id: 2,
                            isCheck: v.valueDoub.includes(2),
                            title: this.getTranslatedText(
                                "secure your grand prize"
                            ),
                            value: v.secure_jackpot_price,
                        },
                    ];
                });
                if (ENABLE_MANAGE_CREDIT_CARDS !== "no") {
                    this.checkShowCard(paramAddToCard);
                }
                this.listCheckouts = paramAddToCard;
                this.isLoadingPage = false;
            } else {
                this.isLoadingPage = false;
            }
        },

        async checkShowCard(listCart) {
            try {
                authService.getBalance().then((res) => {
                    if (res.status === 200) {
                        let paramAddToCardFilter = listCart.filter(
                            (x) => x?.is_recurring === 1
                        );

                        if (
                            parseFloat(res.data.total) <= this.totalAmount ||
                            !isArrayEmpty(paramAddToCardFilter)
                        ) {
                            this.isShowListCard = true;
                        } else {
                            this.isShowListCard = false;
                        }
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },

        // call apitransact
        async callApiTransact(paramCheckout, isStopCallBack) {
            const resp = await gameService.transact(paramCheckout);
            if (resp.status === 200) {
                await authService.removeListCart();

                localStorage.removeItem("list_block");
                localStorage.removeItem("list_block_tmp");
                localStorage.removeItem("total_items");
                this.$store.dispatch("onChangeAnountCart", 0);
                this.listCheckouts = [];
                this.showToast(resp.message, "success");
                this.$store.dispatch("setBalance");
                this.$router.push(`/thank-you?reference=${resp.data.reference}`);
                this.isLoadingBtn = false;
            } else {
                if(isStopCallBack) {
                    setTimeout(() => {
                        this.callApiTransact(paramCheckout, true)
                    }, 5000);
                } else {
                    this.isLoadingBtn = false;
                    this.showToast(resp.message, "error");
                }
            }

        },

        async handlePay() {
            this.isLoadingBtn = true;
            try {
                if (!this.$store.state.isLoggedIn) {
                    this.showToast("please log in", "error");
                    this.$router.push("/login");
                    return false;
                }

                let userInfo = getUserInfo();
                userInfo = JSON.parse(userInfo);
                const respCheckLimit = await gameService.checkLimitGame({
                    user_id: userInfo?.id,
                    quantity: this.$store.state.amoutCart,
                });

                if (!respCheckLimit.data.status) {
                    this.showToast(respCheckLimit.data.message, "error");
                    this.isLoadingBtn = false;
                    return false;
                }

                let totalAmount = this.totalAmount;
                let totalAmountRecurring = 0;
                let games = [];
                this.listCheckouts.map((x) => {
                    let index = games.findIndex(
                        (v) => v.event_id === x.event_id
                    );

                    let itemBets = {
                        type: "jackpot",
                        amount: parseFloat(x.amount),
                        bet: x.bets,
                        draws: "1",
                    };

                    if (x.doubles[0].isCheck) {
                        itemBets["double_jackpot_price"] = parseFloat(
                            x.double_jackpot_price
                        );
                    }
                    if (x.doubles[1].isCheck) {
                        itemBets["secure_jackpot_price"] = parseFloat(
                            x.secure_jackpot_price
                        );
                    }

                    let itemListCart = {
                        bets: [],
                        game_id: x.gameId,
                        game_slug: x.game_slug,
                        event_id: x.event_id,
                    };

                    if (x.is_recurring === 1) {
                        itemBets["is_recurring"] = 1;

                        x.doubles.map((item) => {
                            if (item.isCheck) {
                                totalAmountRecurring += item.value;
                            }
                        });
                        totalAmountRecurring += parseFloat(x.amount);
                    }

                    itemListCart.bets.push(itemBets);
                    if (index === -1) {
                        games.push(itemListCart);
                    } else {
                        games[index].bets.push(itemBets);
                    }
                });

                let paramCheckout = {
                    totalAmount,
                    games,
                };

                const balance = await authService.getBalance();

                let totalNoRecurring =
                    parseFloat(paramCheckout.totalAmount) -
                    totalAmountRecurring;
                let totalMore =
                    parseFloat(totalNoRecurring) -
                    parseFloat(balance.data.total.replaceAll(",", ""));

                switch (true) {
                    case totalAmountRecurring === 0 && totalMore <= 0:
                        this.callApiTransact(paramCheckout)
                        break;
                    case totalAmountRecurring === 0 &&
                        totalMore > 0 &&
                        this.cardSelect.id !== -1:
                        console.log("card select not - 1");
                        this.modalShowCvv = true;
                        this.paramCheckout = paramCheckout;
                        this.totalAmountPayment = parseFloat(totalMore);
                        this.isLoadingBtn = false;
                        break;
                    case totalAmountRecurring === 0 &&
                        totalMore > 0 &&
                        this.cardSelect.id === -1:
                        // console.log('card select - 1');
                        this.totalAmountPayment = totalMore;
                        // this.step = 2;
                        this.paramCheckout = paramCheckout;
                        localStorage.setItem(
                            "cart_checkout",
                            JSON.stringify(paramCheckout)
                        );
                        this.isRecurring = false;
                        this.$bvModal.show("modalMethodPayment");
                        this.isLoadingBtn = false;

                        // const res = await PaymentService.purchaseThawani(param);

                        // if (res.status === 200) {
                        //     if (!isStrEmpty(res.data["checkout_url"])) {
                        //         localStorage.setItem("methodPayment", 2);
                        //         window.location.href = res.data["checkout_url"];
                        //     } else {
                        //         alert(res.data.message);
                        //         // this.showToast(res.data.message, "error");
                        //     }
                        // } else {
                        //     alert(res.message);
                        //     // this.showToast(res.message, "error");
                        // }

                        break;
                    case totalAmountRecurring > 0 && this.cardSelect.id === -1:
                        this.totalAmountPayment =
                            totalAmountRecurring +
                            (parseFloat(totalMore) > 0
                                ? parseFloat(totalMore)
                                : 0);
                        this.step = 2;
                        this.paramCheckout = paramCheckout;
                        this.isRecurring = true;
                        break;
                    case totalAmountRecurring > 0 && this.cardSelect.id !== -1:
                        this.totalAmountPayment =
                            totalAmountRecurring +
                            (parseFloat(totalMore) > 0
                                ? parseFloat(totalMore)
                                : 0);
                        this.modalShowCvv = true;
                        this.paramCheckout = paramCheckout;
                        this.isLoadingBtn = false;

                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.log(error);
            }
        },

        onAddSvv() {
            if (this.card_security_code.length < 3) {
                this.stateCvv = false;
                return false;
            } else {
                this.stateCvv = null;
                this.modalShowCvv = false;
                this.handlePayCard();
            }
        },

        async handlePayCard() {
            this.isLoadingBtn = true;
            let parram = {
                card_id: this.cardSelect.id,
                amount: this.totalAmountPayment,
                card_security_code: this.card_security_code,
            };
            const res = await PaymentService.puscharseByCard(parram);
            if (res.status === 200) {
                let paramCheckout = JSON.stringify(this.paramCheckout);
                if (!isStrEmpty(res.data["3ds_url"])) {
                    localStorage.setItem("methodPayment", 2);
                    localStorage.setItem("cart_checkout", paramCheckout);
                    window.location.href = res.data["3ds_url"];
                } else if (res.data.response_message === "success") {
                    localStorage.setItem("methodPayment", 2);
                    localStorage.setItem("cart_checkout", paramCheckout);
                    await this.$router.push("/payment/successful");
                } else {
                    this.showToast(res.data.response_message, "error");
                }
                this.isLoadingBtn = false;
            } else {
                this.showToast(res.message, "error");
                this.isLoadingBtn = false;
            }
        },

        //clear cart
        async onClearCart() {
            try {
                this.isLoadingButtonConfirm = true;
                const resp = this.$store.state.isLoggedIn
                    ? await authService.removeListCart()
                    : 200;
                if (resp === 200 || resp.status === 200) {
                    const listBlokLocal = JSON.parse(
                        localStorage.getItem("list_block")
                    );
                    const listBlokTmpLocal = JSON.parse(
                        localStorage.getItem("list_block_tmp")
                    );

                    let listBlockRemoveDou = removeDouble(
                        listBlokLocal,
                        listBlokTmpLocal,
                        "id"
                    );

                    listBlockRemoveDou = JSON.stringify(listBlockRemoveDou);

                    this.listCheckouts = [];
                    localStorage.removeItem("list_block_tmp");
                    localStorage.removeItem("total_items");
                    localStorage.setItem("list_block", listBlockRemoveDou);
                    this.$store.dispatch("onChangeAnountCart", 0);

                    this.$bvModal.hide("modal-confirm-remove-block");
                    this.showToast(
                        this.getTranslatedText("Clear Cart Successfully"),
                        "success"
                    );
                    this.isLoadingButtonConfirm = false;
                } else {
                    this.isLoadingButtonConfirm = false;
                }
            } catch (error) {
                console.log(error);
            }
        },

        async handleDeleteInfoItem(id) {
            this.isLoadingButtonConfirm = true;
            let index = this.listCheckouts.findIndex((x) => x.id === id);
            if (index !== -1) {
                let totalTtems = localStorage.getItem("total_items");
                let listBlock = localStorage.getItem("list_block");
                listBlock = !isStrEmpty(listBlock) ? JSON.parse(listBlock) : [];
                let item = this.listCheckouts[index];

                let indexListBlock = listBlock.findIndex(
                    (x) => x.id === item.idBlock
                );

                if (
                    indexListBlock !== -1 &&
                    listBlock[indexListBlock].automatically
                ) {
                    listBlock.splice(indexListBlock, 1);
                } else {
                    if (indexListBlock !== -1 && !isArrayEmpty(listBlock)) {
                        let indexDate = listBlock[
                            indexListBlock
                        ].date.findIndex((x) => x === item.event_id);
                        if (indexDate !== -1) {
                            listBlock[indexListBlock].date.splice(indexDate, 1);
                        }
                    }
                }

                if (isArrayEmpty(listBlock[indexListBlock]?.date)) {
                    listBlock.splice(indexListBlock, 1);
                }
                totalTtems -= 1;

                try {
                    let param = {
                        cart_data: listBlock,
                        items: 1,
                        amount: totalTtems,
                    };

                    const resp = this.$store.state.isLoggedIn
                        ? await authService.saveListCart(param)
                        : 200;

                    if (resp === 200 || resp.status === 200) {
                        this.idIndex = "";

                        let amount = parseFloat(this.totalAmount);
                        amount -= parseFloat(this.listCheckouts[index].amount);
                        this.listCheckouts[index].doubles.map((x) => {
                            if (x.isCheck === true) {
                                amount -= x.value;
                            }
                        });

                        this.listCheckouts.splice(index, 1);

                        this.listCheckouts = this.listCheckouts.map((x, i) => {
                            let item = {
                                ...x,
                                name: `Entry ${i + 1}`,
                            };
                            return {
                                ...item,
                            };
                        });

                        // if(this.$store.state.isLoggedIn) this.checkShowCard(this.listCheckouts);

                        this.$store.dispatch( "onChangeAnountCart", parseInt(totalTtems));

                        localStorage.setItem("total_items", totalTtems);
                        localStorage.setItem("list_block_tmp",JSON.stringify(listBlock));
                        !isArrayEmpty(listBlock) ? localStorage.setItem( "list_block", JSON.stringify(listBlock)) : localStorage.removeItem("list_block");

                        this.$bvModal.hide("modal-confirm-remove-block");
                        this.showToast(this.getTranslatedText("Delete Successfully"), "success" );

                        this.totalAmount = amount;
                        this.isLoadingButtonConfirm = false;
                    }
                } catch (error) {
                    this.isLoadingButtonConfirm = false;
                }
            }
        },

        handleEditInfoItem(id) {
            this.$store.dispatch("onChangeIdEditCheckoutCart", id);
            this.$router.push("/tickets");
        },

        onClickConfirmModal(id) {
            this.idIndex = id;
            this.$bvModal.show("modal-confirm-remove-block");
        },

        onCancelRemove() {
            this.$bvModal.hide("modal-confirm-remove-block");
            this.idIndex = "";
        },

        onScroll(e) {
            const currentScrollPosition =
                window.pageYOffset || document.documentElement.scrollTop;
            this.isScroll = currentScrollPosition > 0;
        },

        async onChangeDouble(index, i) {
            if (index !== -1 && i !== -1) {
                this.listCheckouts[index].doubles[i].isCheck =
                    !this.listCheckouts[index].doubles[i].isCheck;

                let item = this.listCheckouts[index];

                let listBlock = JSON.parse(localStorage.getItem("list_block"));

                let indexListBlock = listBlock.findIndex(
                    (x) => x.id === item.idBlock
                );

                listBlock[indexListBlock]["doubles"] =
                    listBlock[indexListBlock]?.doubles || [];

                let indexDou = listBlock[indexListBlock]["doubles"].findIndex(
                    (x) => x.id === item.event_id
                );
                if (item.doubles[i].isCheck) {
                    if (indexDou !== -1) {
                        listBlock[indexListBlock]["doubles"][
                            indexDou
                        ].value.push(item.doubles[i].id);
                    } else {
                        listBlock[indexListBlock]["doubles"].push({
                            id: item.event_id,
                            value: [item.doubles[i].id],
                        });
                    }
                    this.listCheckouts[index].amountDeducted =
                        item.amountDeducted !== -1
                            ? parseFloat(item.amountDeducted) +
                              parseFloat(item.doubles[i].value)
                            : -1;
                    this.totalAmount += parseFloat(item.doubles[i].value);
                } else {
                    let itemDoubles =
                        listBlock[indexListBlock]["doubles"][indexDou];
                    listBlock[indexListBlock]["doubles"][indexDou].value =
                        itemDoubles.value.filter(
                            (x) => x !== item.doubles[i].id
                        );
                    this.listCheckouts[index].amountDeducted =
                        item.amountDeducted !== -1
                            ? item.amountDeducted -
                              parseFloat(item.doubles[i].value)
                            : -1;
                    this.totalAmount -= parseFloat(item.doubles[i].value);
                }

                let listBlockCart = [...listBlock];
                listBlock = JSON.stringify(listBlock);
                localStorage.setItem("list_block", listBlock);
                localStorage.setItem("list_block_tmp", listBlock);

                if (this.$store.state.isLoggedIn) {
                    this.timer && clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                        this.saveListCart(listBlockCart);
                    }, 1000);
                }
            }
        },

        async saveListCart(listBlock) {
            try {
                let totalTtems = localStorage.getItem("total_items");
                let param = {
                    cart_data: listBlock,
                    items: 1,
                    amount: totalTtems,
                };

                await authService.saveListCart(param);
                this.checkShowCard(this.listCheckouts);
            } catch (error) {
                console.log(error);
            }
        },

        renderClass(number) {
            const className =
                number > this.maxiumBlue && number <= this.maxiumGreen
                    ? "ball-blue"
                    : "ball-green";

            return className;
        },

        onChangeCard() {
            this.$refs.bottomChangeCard.open();
        },

        formatCardNumber() {
            return creditCardMask(this.cardSelect?.card_number || "");
        },

        renderTypeCard(type) {
            switch (true) {
                case type === "Visa":
                    return "visa.png";
                case type === "Mastercard":
                    return "master.png";
                case type === "Amex":
                    return "amex.png";
                default:
                    return "visa.png";
            }
        },

        onClickGoBack() {
            this.step = 1;
            this.isRecurring = false;
        },

        async onSubmitChangeCard() {
            this.isLoadingChangeCard = true;
            try {
                const resp = await cardService.updateDefault(this.cardId);
                if (resp.status === 200) {
                    let index = this.listCards.findIndex(
                        (x) => x.id === this.cardId
                    );
                    if (index !== -1) {
                        let listCart = this.listCards.map((x, i) => ({
                            ...x,
                            is_default: i === index,
                        }));
                        this.cardSelect = this.listCards[index];
                        this.listCards = listCart;
                        this.$refs.bottomChangeCard.close();
                        this.isLoadingChangeCard = false;
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },

        formatLocalePrice(price) {
            return formatNumberMoney(parseFloat(price));
        },

        //action
        onGoBackPage() {
            this.$router.push("/tickets");
        },

        // format price
        formatNumberWinners(number) {
            let list_games = !isStrEmpty(localStorage.getItem("list_games"))
                ? JSON.parse(localStorage.getItem("list_games"))
                : [];

            let price = !isArrayEmpty(list_games)
                ? parseFloat(list_games[0]?.estimated_jackpot) * number
                : 0;

            return renderLocalePrice(parseInt(price), 0);
        },

        renderTitleTicket(text) {
            let textLowercase = text.toLowerCase();
            let number = textLowercase.split(" ")[1];
            textLowercase = textLowercase.replaceAll(
                "entry",
                this.getTranslatedText("entry")
            );

            textLowercase = textLowercase.replaceAll(
                number,
                renderLocaleNumber(parseInt(number))
            );
            return textLowercase;
        },

        renderDate(date) {
            // let locale = this.$store.state.isRtl ? "ar" : "en";
            // moment.locale(locale);

            return moment(date).format("DD/MM/YYYY");
        },

        renderNumberLocale(number) {
            return renderLocaleNumber(number);
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/checkout/_checkout.scss" />
